import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { AddAddressModel } from 'app/modules/address/models/address.model';
import { AddressService } from 'app/modules/address/services/address.service';
import { Constants } from 'app/shared/constant/constants';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ToastrService } from 'ngx-toastr';
import { InputPatterns } from 'app/shared/helper/input-patterns';

@Component({
  selector: 'add-address-card',
  templateUrl: './add-address-card.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AddAddressCardComponent implements OnInit {

  public addAddressModel = new AddAddressModel();
  public showLoader : boolean = false;
  public addressTypeList = Constants.locationTypeList;
  public cityItemList; //= Constants.addressCityList;
  public consumerId : any;
  public editAddressDetails;
  public isPincodeIsValid = false;
  public isPincodeCheck = false;
  public deliveryStatus;
  public isDeliveryStatusCheck = false;
  public addressPattern = InputPatterns.ADDRESS_PATTERN;
  public addressPatternOnInput = InputPatterns.ADDRESS_PATTERN_ONINPUT;
  @Output() childCallbackForAddAddressForm = new EventEmitter<string>();

  constructor(
    public toast: ToastrService,
    public router  : Router,
    public addressService : AddressService,
    public route: ActivatedRoute,
    ) { 
     this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
    }

  ngOnInit() {
  }

  addAddress(data){
    if(data == true && this.isPincodeIsValid){
      this.showLoader = true;
      this.addAddressModel.consumerId = this.consumerId;
      this.addAddressModel.default = true;
      this.addAddressModel.isDefault = false;
      this.addAddressModel.addressLabel = this.addAddressModel.locationType;
      this.addAddressModel.country = "INDIA";

      let localAddAddressRequests: Array<AddAddressModel> = [];
      localAddAddressRequests.push(this.addAddressModel);      


      this.addressService.createConsumerAddress(localAddAddressRequests).subscribe((resp => {
        this.showLoader = false;
        this.toast.success("Address added successfully !");
        this.childCallbackForAddAddressForm.emit('ADDRESS_ADDED');
      }),error=>{
        this.showLoader = false;
        this.toast.error(error.error.message);
      });
    }    
  }
   

  goToBackStep(){
    this.childCallbackForAddAddressForm.emit('ADDRESS_ADDED');
  }

  pincodeCheck() {
    var pincode = this.addAddressModel.postalCode;
    if (pincode && pincode.toString().length == 6) {
      this.showLoader = true;
      this.addressService.verifyPincode(pincode).subscribe((pincodeResp) => {
        // console.log("PINCODE VERIFY", pincodeResp.body);
        let pincodeData = pincodeResp.body;
        this.isPincodeIsValid = true;
        this.isPincodeCheck = true;
        this.addAddressModel.city = undefined;
        this.cityItemList = pincodeData;
        if(this.cityItemList.length == 1) {
          this.addAddressModel.city = this.cityItemList[0].city;
          this.addAddressModel.state = this.cityItemList[0].state;
        }
        this.checkDeliveryAvailbleByPincode();
      }, error => {
        this.isPincodeCheck = true;
        this.isPincodeIsValid = false;
        this.showLoader = false;
      });
    } else {
        this.addAddressModel.city = undefined;
        this.addAddressModel.state = undefined;        
        this.cityItemList = [];
    }
  }

  checkDeliveryAvailbleByPincode() {
    let pincode = this.addAddressModel.postalCode;
    if(pincode && pincode.toString().length == 6) {
      this.showLoader = false;
      this.addressService.isDeliveryAvailbleByPincode(pincode).subscribe((resPincodeData) => {
        // console.log("PINCODE DATA", resPincodeData);
        this.deliveryStatus = resPincodeData.body;
        this.isDeliveryStatusCheck = true;
      }, error => {
        this.isDeliveryStatusCheck = true;
        this.showLoader = false;
      });
    }
  }



}
